import { useState } from "react";
import { ClipboardPaste, Upload } from "lucide-react";

export function MediaDropZone({ accept = "image/*", multiple = false, onFiles, busy = false, busyLabel = "Uploading…", label, hint, icon: Icon = Upload, inputRef, testid, className = "" }) {
  const [over, setOver] = useState(false);

  const pick = (list) => {
    const files = Array.from(list || []).filter((f) => accept === "*" || accept.split(",").some((a) => {
      const t = a.trim();
      return t.endsWith("/*") ? f.type.startsWith(t.slice(0, -1)) : f.type === t;
    }));
    if (files.length) onFiles(multiple ? files : [files[0]]);
  };

  return (
    <div
      tabIndex={0}
      role="button"
      data-testid={testid}
      onClick={() => !busy && inputRef.current?.click()}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); inputRef.current?.click(); } }}
      onPaste={(e) => { if (e.clipboardData?.files?.length) { e.preventDefault(); pick(e.clipboardData.files); } }}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); pick(e.dataTransfer.files); }}
      className={`flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed px-4 text-center text-sm outline-none transition-colors focus:border-[var(--chakra)] focus:ring-2 focus:ring-[var(--chakra-tint)] ${
        over ? "border-[var(--saffron)] bg-[var(--saffron-tint)] text-[var(--saffron-deep)]" : "border-[var(--line)] bg-[var(--paper)] text-stone-500 hover:border-[var(--chakra)] hover:text-[var(--chakra)]"
      } ${busy ? "pointer-events-none opacity-60" : ""} ${className}`}
    >
      <Icon className="h-7 w-7" />
      <span className="font-medium">{busy ? busyLabel : label}</span>
      {!busy && (
        <span className="inline-flex items-center gap-1 text-xs text-stone-400">
          <ClipboardPaste className="h-3.5 w-3.5" /> {hint || "Click to upload · drag & drop · or click here and press Ctrl+V to paste"}
        </span>
      )}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        className="hidden"
        onChange={(e) => { pick(e.target.files); e.target.value = ""; }}
        onClick={(e) => e.stopPropagation()}
        data-testid={testid ? `${testid}-input` : undefined}
      />
    </div>
  );
}
